import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Menu, X } from 'lucide-react';
import LogoPng from '../assets/InitX_Logo.png';


const Nav = styled.nav`
  background: ${props => props.$scrolled ? 'rgba(15, 23, 42, 0.95)' : 'rgba(15, 23, 42, 0.9)'};
  backdrop-filter: blur(10px);
  padding: 0.3rem 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: ${props => props.$scrolled ? '0 2px 20px rgba(0,212,255,0.2)' : 'none'};
  border-bottom: none;
  
  /* &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 8px;
    background: linear-gradient(90deg, 
      transparent 0%, 
      #000000 5%,
      #1e3a8a 15%, 
      #ffffff 30%, 
      #1e3a8a 45%, 
      #000000 60%, 
      #ffffff 75%, 
      #1e3a8a 90%, 
      transparent 100%
    );
    animation: techFlow 3s ease-in-out infinite;
    box-shadow: 
      0 0 20px rgba(30, 58, 138, 0.6),
      0 0 40px rgba(255, 255, 255, 0.4),
      0 0 60px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.5);
    border-radius: 0 0 4px 4px;
  } */
  
  /* &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: repeating-linear-gradient(
      90deg,
      #ffffff 0px,
      #ffffff 3px,
      #1e3a8a 3px,
      #1e3a8a 6px,
      #000000 6px,
      #000000 9px,
      transparent 9px,
      transparent 12px
    );
    animation: techPattern 2s linear infinite;
    z-index: 2;
  } */
  
  @keyframes techFlow {
    0% { 
      opacity: 0.8;
      transform: scaleX(1);
      background-position: 0% 0%;
    }
    25% {
      opacity: 1;
      transform: scaleX(1.01);
      background-position: 25% 0%;
    }
    50% { 
      opacity: 1;
      transform: scaleX(1.02);
      background-position: 50% 0%;
    }
    75% {
      opacity: 1;
      transform: scaleX(1.01);
      background-position: 75% 0%;
    }
    100% {
      opacity: 0.8;
      transform: scaleX(1);
      background-position: 100% 0%;
    }
  }
  
  @keyframes techPattern {
    0% { transform: translateX(0); }
    100% { transform: translateX(16px); }
  }
`;

const LogoImage = styled.img`
  height: 30px;
  width: 30px;
  margin-right: 10px;
  object-fit: contain;
`;

const LogoText = styled.div`
  display: flex;
  align-items: center;
  
  .init {
    font-size: 34px;
    font-weight: 900;
    background: linear-gradient(135deg, 
      #ffffff 0%, 
      #f8f8f8 8%,
      #f0f0f0 16%,
      #e8e8e8 24%,
      #d0d0d0 32%,
      #b8b8b8 40%,
      #a0a0a0 48%,
      #c0c0c0 56%,
      #d8d8d8 64%,
      #e8e8e8 72%,
      #f0f0f0 80%,
      #f8f8f8 88%,
      #ffffff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-family: 'Orbitron', 'Exo', 'Rajdhani', sans-serif;
    letter-spacing: 0px;
    text-shadow: none;
    filter: none;
    position: relative;
    transform: perspective(100px) rotateX(5deg);
    
    &::before {
      content: 'Init';
      position: absolute;
      top: 2px;
      left: 2px;
      font-size: 34px;
      font-weight: 900;
      background: linear-gradient(135deg, #909090, #707070, #505050);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      z-index: -1;
      filter: blur(2px);
      opacity: 0.7;
    }
    
    &::after {
      content: 'Init';
      position: absolute;
      top: 4px;
      left: 4px;
      font-size: 34px;
      font-weight: 900;
      color: rgba(0, 0, 0, 0.2);
      z-index: -2;
      filter: blur(4px);
      opacity: 0.5;
    }
  }
  
  .x {
    font-size: 32px;
    font-weight: 900;
    background: linear-gradient(135deg, #2a094aff 0%, #1E3A8A 50%, #361c4eff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-family: 'Arial Black', 'Arial', sans-serif;
    letter-spacing: 0px;
    margin-left: -1px;
    position: relative;
    transform: perspective(300px) rotateX(5deg);
    text-shadow: 
      1px 1px 0 #d12dddff,
      2px 2px 0 #1E3A8A,
      3px 3px 0 #3a056fff,
      4px 4px 8px rgba(124, 58, 237, 0.4);
    filter: 
      drop-shadow(0 2px 4px rgba(168, 85, 247, 0.3))
      drop-shadow(0 1px 0 rgba(30, 58, 138, 0.1));
    
    &::before {
      content: 'X';
      position: absolute;
      top: 1px;
      left: 1px;
      font-size: 32px;
      font-weight: 900;
      color: rgba(124, 58, 237, 0.2);
      z-index: -1;
    }
    
    &::after {
      display: none;
    }
  }
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0 30px;
  
  @media (max-width: 768px) {
    padding: 0 20px;
  }
  
  @media (max-width: 480px) {
    padding: 0 15px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.3s ease;
  outline: none;
  flex-shrink: 0;
  cursor: pointer;
  
  &:focus {
    outline: none;
    box-shadow: none;
  }
  
  &:focus-visible {
    outline: none;
    box-shadow: none;
  }
  
  &:hover {
    transform: scale(1.02);
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: auto;
  
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(120px, 1fr));
    gap: 14px;
    position: fixed;
    inset: 0;
    min-height: 100dvh;
    place-content: center;
    justify-items: center;
    align-content: center;
    padding: max(24px, env(safe-area-inset-top)) 24px max(24px, env(safe-area-inset-bottom));
    background: rgba(2, 6, 23, 0.72);
    backdrop-filter: blur(12px);
    margin-left: 0;
    z-index: 1001;
    opacity: ${props => props.$isOpen ? 1 : 0};
    visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
    pointer-events: ${props => props.$isOpen ? 'auto' : 'none'};
    transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(8px)'};
    transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease;
  }
`;

const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    background: rgba(0, 212, 255, 0.1);
    color: #00d4ff;
  }
  
  @media (max-width: 768px) {
    color: #e2e8f0;
    width: 100%;
    max-width: 180px;
    text-align: center;
    justify-self: center;
    padding: 14px 16px;
    border: 1px solid rgba(148, 163, 184, 0.25);
    background: rgba(15, 23, 42, 0.6);
    box-shadow: 0 8px 20px rgba(2, 6, 23, 0.18);
    
    &:hover {
      background: rgba(14, 165, 233, 0.18);
      color: #7dd3fc;
      border-color: rgba(125, 211, 252, 0.45);
    }
  }
`;

const CTAButton = styled(Link)`
  background: linear-gradient(135deg, #0ea5e9 0%, #00d4ff 50%, #3b82f6 100%);
  color: white;
  text-decoration: none;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 25px;
  transition: all 0.3s ease;
  font-size: 14px;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 212, 255, 0.4);
    background: linear-gradient(135deg, #0284c7 0%, #0ea5e9 50%, #2563eb 100%);
  }
  
  @media (max-width: 768px) {
    grid-column: 1 / -1;
    width: min(320px, 100%);
    justify-self: center;
    text-align: center;
    margin-top: 4px;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: 1px solid rgba(0,212,255,0.3);
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-left: auto;
  position: relative;
  z-index: 1002;
  
  &:hover {
    background: rgba(0,212,255,0.1);
    border-color: #00d4ff;
  }
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const StickyNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/';
    }
  };

  return (
    <Nav $scrolled={scrolled}>
      <NavContainer>
        <LogoContainer onClick={handleLogoClick}>
          <LogoImage src={LogoPng} alt="InitX" />
          <LogoText>
            <span className="init">Init</span>
            <span className="x">X</span>
          </LogoText>
        </LogoContainer>
        
        <NavLinks $isOpen={mobileMenuOpen}>
          <NavLink to="/" onClick={handleLinkClick}>Home</NavLink>
          <NavLink to="/about" onClick={handleLinkClick}>About</NavLink>
          <NavLink to="/services" onClick={handleLinkClick}>Services</NavLink>
          <NavLink to="/products" onClick={handleLinkClick}>Products</NavLink>
          <NavLink to="/blogs" onClick={handleLinkClick}>Blog</NavLink>
          <NavLink to="/contact" onClick={handleLinkClick}>Contact</NavLink>
          <CTAButton to="/services" onClick={handleLinkClick}>Get Started</CTAButton>
        </NavLinks>

        <MobileMenuButton 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </MobileMenuButton>
      </NavContainer>
    </Nav>
  );
};

export default StickyNavbar;